export const emBase64 = (string) => {
  return string ? btoa(string) : ""
}

export const deBase64 = (string) => {
  return string ? atob(string) : ""
}

export const getProductKey = ({
  documentNumber,
  productId,
  agreementId,
  serviceId
}) => {
  const string = `P${documentNumber}${productId}${agreementId}${serviceId}`
  return emBase64(string)
}

export const getContractKey = ({
  documentNumber,
  productId,
  agreementId,
  serviceId
}) => {
  const string = `C${documentNumber}${productId}${agreementId}${serviceId}`
  return emBase64(string)
}

export const getBalanceKey = ({ documentNumber, serviceId }) => {
  const string = `C${documentNumber}${serviceId}`
  return emBase64(string)
}

export const getServiceKey = ({ serviceId }) => {
  return emBase64(serviceId)
}

export function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()

    reader.onload = () => {
      const base64String = reader.result.split(",")[1]
      resolve(base64String)
    }

    reader.onerror = (error) => {
      reject(error)
    }

    reader.readAsDataURL(file)
  })
}



// WEBPACK FOOTER //
// ./src/services/utils/generateBase64.js